// Styles injectés dans le Shadow DOM du widget.
// Tout est scopé : aucun risque de conflit avec Wix/Shopify/site hôte.

export const STYLES = `
:host {
  --eteka-primary: #e8842c;
  --eteka-primary-dark: #b0421a;
  --eteka-bg: #fdfbf7;
  --eteka-text: #2a2a2a;
  --eteka-text-muted: #6b6b6b;
  --eteka-bubble-bot: #fff;
  --eteka-bubble-user: #2a2a2a;
  --eteka-bubble-user-text: #fff;
  --eteka-border: #ece6df;
  --eteka-shadow: 0 10px 30px rgba(0,0,0,0.12);
  --eteka-radius: 16px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

.eteka-root {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 2147483000;
}

.eteka-launcher {
  width: 60px; height: 60px;
  border-radius: 50%;
  background: var(--eteka-primary);
  border: none;
  box-shadow: var(--eteka-shadow);
  cursor: pointer;
  display: flex; align-items: center; justify-content: center;
  transition: transform .2s ease;
}
.eteka-launcher:hover { transform: scale(1.05); }
.eteka-launcher svg { width: 36px; height: 36px; }

.eteka-panel {
  width: 380px;
  max-width: calc(100vw - 40px);
  height: 600px;
  max-height: calc(100vh - 60px);
  background: var(--eteka-bg);
  border-radius: var(--eteka-radius);
  box-shadow: var(--eteka-shadow);
  display: none;
  flex-direction: column;
  overflow: hidden;
  color: var(--eteka-text);
}
.eteka-panel[data-open="true"] { display: flex; }

.eteka-header {
  display: flex; align-items: center; gap: 12px;
  padding: 14px 16px;
  background: #fff;
  border-bottom: 1px solid var(--eteka-border);
}
.eteka-header-text { flex: 1; }
.eteka-header-title { font-weight: 600; font-size: 15px; }
.eteka-header-sub { font-size: 12px; color: var(--eteka-text-muted); }

.eteka-close {
  background: none; border: none; cursor: pointer; padding: 6px;
  color: var(--eteka-text-muted); font-size: 20px; line-height: 1;
}
.eteka-close:hover { color: var(--eteka-text); }

.eteka-messages {
  flex: 1;
  overflow-y: auto;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.eteka-msg {
  max-width: 85%;
  padding: 10px 14px;
  border-radius: 14px;
  font-size: 14px;
  line-height: 1.45;
  word-wrap: break-word;
  animation: eteka-fadein .25s ease;
}
.eteka-msg.bot {
  align-self: flex-start;
  background: var(--eteka-bubble-bot);
  color: var(--eteka-text);
  border-bottom-left-radius: 4px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.04);
}
.eteka-msg.user {
  align-self: flex-end;
  background: var(--eteka-bubble-user);
  color: var(--eteka-bubble-user-text);
  border-bottom-right-radius: 4px;
}

@keyframes eteka-fadein {
  from { opacity: 0; transform: translateY(4px); }
  to { opacity: 1; transform: translateY(0); }
}

.eteka-typing {
  align-self: flex-start;
  display: flex; gap: 4px;
  padding: 12px 14px;
  background: var(--eteka-bubble-bot);
  border-radius: 14px;
  border-bottom-left-radius: 4px;
}
.eteka-typing span {
  width: 6px; height: 6px; border-radius: 50%;
  background: #bbb;
  animation: eteka-bounce 1.2s infinite;
}
.eteka-typing span:nth-child(2) { animation-delay: 0.15s; }
.eteka-typing span:nth-child(3) { animation-delay: 0.3s; }
@keyframes eteka-bounce {
  0%, 60%, 100% { transform: translateY(0); opacity: 0.5; }
  30% { transform: translateY(-4px); opacity: 1; }
}

.eteka-options {
  display: flex; flex-wrap: wrap; gap: 6px;
  padding: 8px 16px 12px 16px;
  border-top: 1px solid var(--eteka-border);
  background: #fff;
}
.eteka-option {
  background: #fff;
  color: var(--eteka-text);
  border: 1px solid var(--eteka-border);
  border-radius: 999px;
  padding: 8px 14px;
  font-size: 13px;
  cursor: pointer;
  transition: all .15s ease;
}
.eteka-option:hover {
  border-color: var(--eteka-primary);
  background: var(--eteka-primary);
  color: #fff;
}
.eteka-option.eteka-option-other {
  border-style: dashed;
  font-style: italic;
}
.eteka-option.eteka-option-skip {
  color: var(--eteka-text-muted);
  border-color: var(--eteka-border);
  background: transparent;
}
.eteka-option.eteka-option-skip:hover {
  color: #fff;
  background: var(--eteka-text-muted);
  border-color: var(--eteka-text-muted);
}

.eteka-freetext {
  display: flex; gap: 6px;
  padding: 8px 16px 12px 16px;
  border-top: 1px solid var(--eteka-border);
  background: #fff;
}
.eteka-freetext input {
  flex: 1;
  border: 1px solid var(--eteka-border);
  border-radius: 999px;
  padding: 8px 14px;
  font-size: 13px;
  font-family: inherit;
  outline: none;
  transition: border-color .15s ease;
}
.eteka-freetext input:focus {
  border-color: var(--eteka-primary);
}
.eteka-freetext button {
  border: none;
  background: var(--eteka-primary);
  color: white;
  border-radius: 999px;
  padding: 8px 14px;
  font-size: 13px;
  cursor: pointer;
}
.eteka-freetext button:hover { background: var(--eteka-primary-dark); }
.eteka-freetext button:disabled { background: #ccc; cursor: not-allowed; }
.eteka-freetext-cancel {
  background: transparent !important;
  color: var(--eteka-text-muted) !important;
  border: 1px solid var(--eteka-border) !important;
}

.eteka-footer {
  display: flex; align-items: center; justify-content: space-between;
  padding: 8px 16px;
  background: #fff;
  border-top: 1px solid var(--eteka-border);
  font-size: 11px;
  color: var(--eteka-text-muted);
}

/* Jauge -------------------------------------------------- */
.eteka-gauge {
  flex-shrink: 0;
}
.eteka-gauge-bg { stroke: #ece6df; }
.eteka-gauge-fg {
  stroke: var(--eteka-primary);
  transition: stroke-dashoffset 0.6s cubic-bezier(.2,.7,.3,1), stroke 0.3s ease;
}
.eteka-gauge[data-confidence="high"] .eteka-gauge-fg { stroke: #4caf50; }
.eteka-gauge[data-confidence="mid"] .eteka-gauge-fg  { stroke: var(--eteka-primary); }
.eteka-gauge[data-confidence="low"] .eteka-gauge-fg  { stroke: #d4af37; }
.eteka-gauge-letter {
  font-size: 22px; font-weight: 700; fill: var(--eteka-text);
}
.eteka-gauge-percent {
  font-size: 10px; fill: var(--eteka-text-muted);
}

/* Avatar -------------------------------------------------- */
.eteka-avatar { flex-shrink: 0; }
.eteka-avatar svg {
  display: block;
  filter: drop-shadow(0 2px 4px rgba(0,0,0,0.08));
}
.eteka-mouth { transition: d 0.08s linear; }
.eteka-eye-l, .eteka-eye-r {
  transition: transform 0.12s ease;
}

/* Input de mesure (cm) ----------------------------------- */
.eteka-measure { align-items: center; }
.eteka-measure input {
  flex: 1;
  border: 1px solid var(--eteka-border);
  border-radius: 999px;
  padding: 8px 14px;
  font-size: 16px;
  font-family: inherit;
  outline: none;
}
.eteka-measure input:focus { border-color: var(--eteka-primary); }
.eteka-measure .eteka-measure-unit {
  font-size: 13px; color: var(--eteka-text-muted);
}
.eteka-input-error { border-color: #e74c3c !important; }

/* Cartes produits recommandés ---------------------------- */
.eteka-reco {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin: 8px 0;
}
.eteka-product {
  display: flex;
  gap: 12px;
  background: #fff;
  border: 1px solid var(--eteka-border);
  border-radius: 12px;
  padding: 10px;
  align-items: center;
  box-shadow: 0 1px 3px rgba(0,0,0,0.04);
}
.eteka-product-img {
  width: 64px; height: 64px;
  border-radius: 8px;
  object-fit: cover;
  flex-shrink: 0;
  background: #f3ece6;
}
.eteka-product-img-placeholder {
  display: flex; align-items: center; justify-content: center;
  font-size: 26px; font-weight: 700; color: var(--eteka-primary);
}
.eteka-product-body { flex: 1; min-width: 0; }
.eteka-product-name { font-weight: 600; font-size: 15px; margin-bottom: 2px; }
.eteka-product-reason {
  font-size: 12.5px; color: var(--eteka-text-muted); line-height: 1.4;
}
.eteka-product-meta {
  display: flex; align-items: center; gap: 8px; margin-top: 6px;
  flex-wrap: wrap;
}
.eteka-badge-ok {
  font-size: 11px; color: #2e7d32; background: #e8f5e9;
  padding: 2px 8px; border-radius: 999px;
}
.eteka-badge-ko {
  font-size: 11px; color: #c62828; background: #ffebee;
  padding: 2px 8px; border-radius: 999px;
}
.eteka-product-link {
  font-size: 13px; font-weight: 500;
  color: var(--eteka-primary); text-decoration: none;
}
.eteka-product-link:hover { text-decoration: underline; }

/* Résultat final ----------------------------------------- */
.eteka-result {
  padding: 16px;
  background: #fff;
  border: 1px solid var(--eteka-border);
  border-radius: 12px;
  margin: 8px 0;
}
.eteka-result-title {
  font-size: 18px; font-weight: 700; margin-bottom: 6px;
  color: var(--eteka-primary-dark);
}
.eteka-result-desc {
  font-size: 13px; line-height: 1.5;
}

/* Cacher le launcher quand le panel est ouvert (évite qu'il flotte
   derrière sur mobile et qu'il chevauche le panel sur desktop étroit). */
.eteka-root:has(.eteka-panel[data-open="true"]) .eteka-launcher {
  display: none;
}

/* Mobile -------------------------------------------------- */
@media (max-width: 600px) {
  .eteka-root {
    bottom: 0;
    right: 0;
    left: 0;
    top: auto;
  }
  .eteka-launcher {
    /* Plus gros et avec marge anti-encoche/safe-area iOS. */
    width: 56px;
    height: 56px;
    margin-bottom: env(safe-area-inset-bottom, 0);
    margin-right: env(safe-area-inset-right, 16px);
    position: fixed;
    bottom: 16px;
    right: 16px;
  }
  .eteka-panel {
    position: fixed;
    inset: 0;
    width: 100vw;
    height: 100vh;            /* fallback */
    height: 100dvh;           /* tient compte de la barre d'URL mobile */
    max-height: 100dvh;
    max-width: 100vw;
    border-radius: 0;
    /* Padding pour respecter l'encoche iPhone + barre de gestes home. */
    padding-top: env(safe-area-inset-top);
    padding-bottom: env(safe-area-inset-bottom);
  }
  .eteka-header {
    padding: 12px 14px;
  }
  .eteka-avatar svg { width: 52px; height: 52px; }
  .eteka-gauge svg { width: 78px; height: 78px; }
  .eteka-header-title { font-size: 16px; }
  .eteka-header-sub { font-size: 12px; }
  .eteka-close {
    /* Touch target ≥ 44px (Apple HIG) */
    width: 44px; height: 44px;
    display: flex; align-items: center; justify-content: center;
    font-size: 26px;
  }
  .eteka-messages {
    padding: 14px;
    /* Évite que le clavier mobile couvre la zone de saisie. */
    -webkit-overflow-scrolling: touch;
  }
  .eteka-msg {
    max-width: 88%;
    font-size: 15px;
    line-height: 1.5;
  }
  .eteka-options {
    padding: 10px 14px 14px 14px;
    gap: 8px;
  }
  .eteka-option {
    /* Touch target confortable, lisibilité. */
    min-height: 44px;
    padding: 10px 16px;
    font-size: 14px;
  }
  .eteka-freetext {
    padding: 10px 14px;
    gap: 8px;
  }
  .eteka-freetext input {
    /* CRITIQUE : iOS zoome automatiquement sur les inputs < 16px. */
    font-size: 16px;
    padding: 10px 14px;
    min-height: 44px;
  }
  .eteka-freetext button {
    min-height: 44px;
    padding: 10px 16px;
    font-size: 14px;
  }
  .eteka-freetext-cancel {
    min-width: 44px;
  }
  .eteka-result {
    margin: 8px 0;
    padding: 14px;
  }
}

/* Très petits écrans (iPhone SE, etc.) ------------------- */
@media (max-width: 360px) {
  .eteka-avatar svg { width: 44px; height: 44px; }
  .eteka-gauge svg { width: 68px; height: 68px; }
  .eteka-header-sub { display: none; }
  .eteka-msg { font-size: 14px; }
}

/* Landscape mobile : panel sans header trop haut --------- */
@media (max-height: 500px) and (max-width: 900px) {
  .eteka-header { padding: 8px 12px; }
  .eteka-avatar svg { width: 40px; height: 40px; }
  .eteka-gauge svg { width: 56px; height: 56px; }
  .eteka-header-sub { display: none; }
}
`;
